import { Route, Routes } from "react-router-dom";
import Home from "./Component/Home/Home";
import About from "./Component/About/About";
import Dashboard from "./Component/ProfileDashboard/Dashboard";
import ContactUs from "./Component/Contact Us/ContactUs";
import Register from "./Component/Login-Register/Register";
import LoginForm from "./Component/Login-Register/LoginForm";
import NotFound from "./Component/404/NotFound";
import MovieScreenDetails from "./pages/MovieScreenDetails";
import AuthInitializer from "./Component/Auth/AuthInitializer";
import ProtectedRoute from "./Component/Auth/ProtectedRoute";
import GuestRoute from "./Component/Auth/GuestRoute";
import Theatres from "./Component/Theatres/theatresListing";
import Faq from "./Component/FAQ's/Faq";
import TermsOfService from "./Component/Policies/termsOfService";
import PrivacyPolicy from "./Component/Policies/privacyPolicy";
import RefundPolicy from "./Component/Policies/refundPolicy";
import ShippingPolicy from "./Component/Policies/shippingPolicy";
import { API } from "./constants";
import { useEffect } from "react";
import useCompanyStore from "./hooks/useCompanyStore";
import PaymentPage from "./pages/PaymentScreen";
import Cart from "./pages/Cart";
import FoodMenu from "./pages/FoodMenu";

function App() {
  const { setCompanyId } = useCompanyStore();

  useEffect(() => {
    const fetchCompanyByDomain = async () => {
      try {
        const domain = window.location.hostname.toLowerCase();

        const response = await fetch(
          `${API.RESOLVE_COMPANY}?domain=${domain}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          },
        );

        const result = await response.json();

        if (!response.ok || !result.status) {
          throw new Error(result?.message || "Company not found");
        }

        setCompanyId(result.data.companyId);
      } catch (error) {
        console.error("Resolve company error:", error);
      }
    };

    fetchCompanyByDomain();
  }, [setCompanyId]);

  return (
    <AuthInitializer>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/screens/:id" element={<MovieScreenDetails />} />
          <Route path="/about-us" element={<About />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <ProtectedRoute>
                <PaymentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <ProtectedRoute>
                <Cart />
              </ProtectedRoute>
            }
          />
          <Route path="/food-menu" element={<FoodMenu />} />
          <Route path="/theatres" element={<Theatres />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route
            path="/login"
            element={
              <GuestRoute>
                <LoginForm />
              </GuestRoute>
            }
          />

          <Route
            path="/register"
            element={
              <GuestRoute>
                <Register />
              </GuestRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </AuthInitializer>
  );
}

export default App;
